import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { ESPN_HEROS_BASE_URL } from '../urls';

export const espnHero2000x2818: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'background',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1000,
      top: 1409,
      width: 2000,
      height: 2818,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/backgrounds/2000x2818.png`,
      crossOrigin: 'anonymous',
      filters: [],
      selectable: false,
      evented: false
    },
    {
      cropX: 0,
      cropY: 0,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 999.7982,
      top: 1408.7156,
      width: 2000,
      height: 2818,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.9987,
      scaleY: 0.9987,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/overlays/shadows/background-top_2000x2818.png`,
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-0',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 330.6143,
      top: 1277.5478,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0181,
      scaleY: 1.0181,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/ansu-fati/ansu-fati-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-3',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1710.1764,
      top: 1273.5005,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0284,
      scaleY: 1.0284,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/francisco-sierralta/francisco-sierralta-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-2',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1247.102,
      top: 1436.7613,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0356,
      scaleY: 1.0356,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/diomande-sinaly/diomande-sinaly-005.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-1',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 784.73,
      top: 1436.3127,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0255,
      scaleY: 1.0255,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/golovin-aleksandr/golovin-aleksandr-004.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 999.7982,
      top: 1408.7156,
      width: 2000,
      height: 2818,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.9998,
      scaleY: 0.9998,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/overlays/shadows/players_2000x2818.png`,
      crossOrigin: null,
      filters: []
    }
  ],
  background: '#f0f0f0'
};
